var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "chat-list-container" }, [
    _c("div", { staticClass: "chat-header" }, [
      _c("div", { staticClass: "chat-date" }, [
        _vm._v(" " + _vm._s(_vm.currentDate) + " "),
      ]),
    ]),
    _c(
      "div",
      { ref: "scroll", staticClass: "chat-list" },
      [
        _c("div", { staticClass: "chat-message bot" }, [
          _c("img", {
            staticClass: "profile-icon",
            attrs: {
              src: require("@/assets/images/chatbot.png"),
              alt: "Profile",
            },
          }),
          _c("div", { staticClass: "message-box" }, [
            _c("pre", { staticClass: "message-content" }, [
              _vm._v(_vm._s(_vm.$t("chatBot.descriptionData"))),
            ]),
          ]),
        ]),
        _vm._l(_vm.chatList, function (message, index) {
          return _c(
            "div",
            {
              key: index,
              staticClass: "chat-message",
              class: [_vm.isMe(message.userId) ? "user" : "bot"],
            },
            [
              _c("img", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.isMe(message.userId),
                    expression: "!isMe(message.userId)",
                  },
                ],
                staticClass: "profile-icon",
                attrs: {
                  src: require("@/assets/images/chatbot.png"),
                  alt: "Profile",
                },
              }),
              _c("div", { staticClass: "message-box" }, [
                _c("pre", { staticClass: "message-content" }, [
                  _vm._v(_vm._s(message.text)),
                ]),
              ]),
              _c("div", { staticClass: "message-time" }, [
                _vm._v(_vm._s(message.time)),
              ]),
            ]
          )
        }),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.isChatSent,
                expression: "isChatSent",
              },
            ],
            staticClass: "chat-message bot",
          },
          [
            _c("img", {
              staticClass: "profile-icon",
              attrs: {
                src: require("@/assets/images/chatbot.png"),
                alt: "Profile",
              },
            }),
            _c(
              "div",
              { staticClass: "message-box" },
              [_c("GrmLoadingCircle")],
              1
            ),
          ]
        ),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }